/* eslint-disable no-new-func */
// import componentHelper from 'src/js/customMdParse/componentHelper'

export default class NoteTemplate {
  constructor (raw) {
    this._raw = raw
    this.id = this._raw.id
    this.name = this._raw.name
    this.description = this._raw.description
    this.enabled = this._raw.enabled

    try {
      var localScriptContent = '';
      (this._raw.scripts || []).forEach(s => {
        if (s.isGlobal === false) {
          localScriptContent += s.content + '\n'
        }
      })
      this.UserClass = Function('"use strict"; \n' + localScriptContent + '\nreturn (' + this._raw.template + ')\n' +
      '//# sourceURL=' + this.name.replace(/[ \t!@#$%^&*~/\\]/g, '-') + '.js')()
      // if (this.UserClass.formatTreeItem) this.formatTreeItem = this.UserClass.formatTreeItem
      // onLoad needs to be static!
      if (this.UserClass.onLoad) this.onLoad = this.UserClass.onLoad
      // if (this.UserClass.onView) this.onView = this.UserClass.onView
      // if (this.UserClass.onSave) this.onSave = this.UserClass.onSave
    } catch (err) {
      console.log('Couldn\'t parse template: ' + this.name + ' (' + this._raw.id + ')')
      console.warn(err)
    }
  }
}
